import React, { useEffect, useState } from 'react';
import { FEATURES } from './landingData';
import LandingSection from './LandingSection';
import LandingCard from './LandingCard';
import {
  Carousel,
  CarouselContent,
  CarouselItem,
} from '../ui/carousel';

function FeatureCard({ feature }) {
  const Icon = feature.icon;
  return (
    <LandingCard className="h-full p-5" hover>
      <div className="flex items-center gap-2 text-sm font-semibold text-white">
        <Icon className="h-4 w-4 text-blue-400" />
        {feature.title}
      </div>
      <p className="mt-2 text-xs leading-relaxed text-white/50">{feature.desc}</p>
    </LandingCard>
  );
}

function CarouselDots({ count, active }) {
  return (
    <div className="mt-4 flex justify-center gap-1.5 md:hidden">
      {Array.from({ length: count }).map((_, i) => (
        <span
          key={i}
          className={`h-1.5 rounded-full transition-all ${
            i === active ? 'w-4 bg-blue-400' : 'w-1.5 bg-white/20'
          }`}
        />
      ))}
    </div>
  );
}

export default function LandingFeatures() {
  const [api, setApi] = useState(null);
  const [active, setActive] = useState(0);

  useEffect(() => {
    if (!api) return undefined;
    const onSelect = () => setActive(api.selectedScrollSnap());
    onSelect();
    api.on('select', onSelect);
    return () => api.off('select', onSelect);
  }, [api]);

  const pairs = [];
  for (let i = 0; i < FEATURES.length; i += 2) {
    pairs.push(FEATURES.slice(i, i + 2));
  }

  return (
    <LandingSection
      id="features"
      title="Why choose School Analytics"
      subtitle="Clean workflows for attendance, fees, academics, and communication—built for speed and clarity."
      innerClassName=""
    >

      <div className="mt-5 md:hidden">
        <Carousel setApi={setApi} opts={{ align: 'start', loop: false }}>
          <CarouselContent>
            {pairs.map((pair, idx) => (
              <CarouselItem key={idx}>
                <div className="grid gap-3">
                  {pair.map((f) => (
                    <FeatureCard key={f.title} feature={f} />
                  ))}
                </div>
              </CarouselItem>
            ))}
          </CarouselContent>
        </Carousel>
        <CarouselDots count={pairs.length} active={active} />
      </div>

      <div className="mt-5 hidden gap-4 md:grid md:grid-cols-2 lg:grid-cols-4">
        {FEATURES.map((f) => (
          <FeatureCard key={f.title} feature={f} />
        ))}
      </div>
    </LandingSection>
  );
}
